import { Show, type Component } from 'solid-js';
import LoanCards from '~/features/loan-cards';
import { borrowRate, borrowedIncome, borrowedYield, carryPerMonth, deductibleInterest, leverage, spread, totalDebt, totalInterest } from '~/stores/portfolio-store';
import { focusedLoanId } from '~/stores/loans-view-store';
import Loans from '~/features/loans';
import Transactions from '~/features/transactions';

// The cards say what the borrowing is doing; the table is where you change it.
// The pane below has no toolbar of its own — its heading repeated the lit nav
// item, and the leverage and deductibility notes beside it are now figures on
// the cards rather than a sentence nobody reads twice.
// No gap between the cards and the table: the cards carry their own bottom rule
// now, and a 1px seam under a 1px border renders as 2px.
const LoansPage: Component = () => (
    <>
    <div class='flex-1 min-w-0 flex flex-col'>
        {/* Hidden while one loan fills the page: they are the totals across
            every loan, and a book-wide figure over a single loan reads as that
            loan's. Same rule the Accounts page follows. */}
        <Show when={focusedLoanId() == null}>
        <div class='shrink-0'>
            <LoanCards
                figures={{
                    carryPerMonth: carryPerMonth(),
                    spread: spread(),
                    // The yield on the borrowed money, not on the book — the
                    // card sits over the loans and is about them.
                    yieldPct: borrowedYield(),
                    interestPerYear: totalInterest(),
                    borrowRate: borrowRate(),
                    debt: totalDebt(),
                    leverage: leverage(),
                    deductiblePerYear: deductibleInterest(),
                    dividendsPerYear: borrowedIncome(),
                }}
            />
        </div>
        </Show>
        <div class='flex-1 min-h-0'>
            <Loans />
        </div>
    </div>

    {/* The blotter, beside the loan rather than under it, and open the moment
        you open the loan.

        Not hidden behind a button the way an account's is. An account is a
        container you look at to see what is in it; a loan is a question about
        where money went, and the trades naming it are the answer — so on this
        screen the blotter is the point rather than the evidence you go and
        fetch.

        Buys only, and structurally so: a sale names no loan, because a disposal
        is borrowed money coming back rather than going out. The sale is still
        felt — it releases the loan's share of the cost base pro rata — so the
        table on the left shrinks while this list does not. That is the
        difference between what the loan bought and what it is still in. */}
    <Show when={focusedLoanId()}>
        <div class='w-1/4 shrink-0'>
            <Transactions loanId={focusedLoanId()!} />
        </div>
    </Show>
    </>
);

export default LoansPage;
